import axios from 'axios';

const defaultBaseUrl = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: defaultBaseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Prevent multiple redirects on repeated 401s
let isRedirectingToLogin = false;
let isRedirectingToVerify = false;

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorCode = error.response?.data?.code;
    const requestUrl = error.config?.url || '';

    if (error.response?.status === 403 && errorCode === 'EMAIL_NOT_VERIFIED') {
      const isVerifyCall = requestUrl.includes('/auth/verify-email') || requestUrl.includes('/auth/resend-verification');
      const alreadyOnVerify = typeof window !== 'undefined' && window.location.pathname === '/verify-email';

      if (!isVerifyCall && !alreadyOnVerify && !isRedirectingToVerify) {
        isRedirectingToVerify = true;
        setTimeout(() => {
          window.location.href = '/verify-email';
        }, 50);
      }

      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      // Avoid loops during login/register calls or when already redirecting
      const isAuthCall = requestUrl.includes('/auth/login') || requestUrl.includes('/auth/register');
      const alreadyOnLogin = typeof window !== 'undefined' && window.location.pathname === '/login';

      if (!isAuthCall && !isRedirectingToLogin && !alreadyOnLogin) {
        isRedirectingToLogin = true;
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // slight delay to let any UI updates settle and to coalesce multiple 401s
        setTimeout(() => {
          window.location.href = '/login';
        }, 50);
      }
    }
    return Promise.reject(error);
  }
);

export default api;




